import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M26.7 8H5.3a2.7 2.7 0 0 0-2.6 2.7v10.6c0 1.5 1.2 2.7 2.6 2.7h21.4c1.4 0 2.6-1.2 2.6-2.7V10.7c0-1.5-1.2-2.7-2.6-2.7M5.3 5.3c-3 0-5.3 2.4-5.3 5.4v10.6c0 3 2.4 5.4 5.3 5.4h21.4c3 0 5.3-2.4 5.3-5.4V10.7c0-3-2.4-5.4-5.3-5.4z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M30.7 13.3c0 .8-.6 1.4-1.4 1.4-3.6 0-6.6-3-6.6-6.7a1.3 1.3 0 1 1 2.6 0 4 4 0 0 0 4 4c.8 0 1.4.6 1.4 1.3m-28 4a1.3 1.3 0 1 0 0 2.7 4 4 0 0 1 4 4 1.3 1.3 0 1 0 2.6 0c0-3.7-3-6.7-6.6-6.7m26.6 0a1.3 1.3 0 1 1 0 2.7 4 4 0 0 0-4 4 1.3 1.3 0 1 1-2.6 0c0-3.7 3-6.7 6.6-6.7M2.7 14.7a1.3 1.3 0 1 1 0-2.7 4 4 0 0 0 4-4 1.3 1.3 0 0 1 2.6 0c0 3.7-3 6.7-6.6 6.7"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16 18.7a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4m0 2.6a5.3 5.3 0 1 0 0-10.6 5.3 5.3 0 0 0 0 10.6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }